import React, { Component } from 'react';
import {createMarkup} from './Factory'; 
import {PopupboxManager,PopupboxContainer} from 'react-popupbox';
import lefticon from '../images/angle-left.svg';
import righicon from '../images/angle-right.svg';
import downloadicon from '../images/download.svg';
import downloadiconblack from '../images/download-black.svg';
//import fileDownload from 'js-file-download';

class PressImage extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			image:this.props.image,
			image_small:this.props.image_small
		}
		this.handleNext = this.handleNext.bind(this);	
		this.handlePrevious = this.handlePrevious.bind(this);	
		this.openPopupbox = this.openPopupbox.bind(this);	
		this.closePopupbox = this.closePopupbox.bind(this);	
		this.handleDownload = this.handleDownload.bind(this);	
	}
	closePopupbox() {
		document.body.classList.remove('no-scroll');
	}
	handleNext(){
		this.props.handleNext(this.props.id);
	}
	handlePrevious(){
		this.props.handlePrevious(this.props.id);
	}
	handleDownload(){
		let index = this.state.image.lastIndexOf("/") + 1;
		var filename = this.state.image.substr(index);
		console.log(filename);
		//fileDownload(this.state.image,filename);
		window.open('https://taxispalais.art/download.php?file='+this.state.image,'_blank');
	}
	openPopupbox() {
	  document.body.classList.add('no-scroll');
	  PopupboxManager.open({
		content:<div> 
					<img alt={this.props.desc} src={this.state.image_small} />
					<div className="nav">
						<span className="left" onClick={this.handlePrevious}><img alt="navigate left" src={lefticon} /></span>
						<span className="right" onClick={this.handleNext}><img alt="navigate right" src={righicon} /></span>
					</div>
					<a href="javascript:void(0)" onClick={this.handleDownload} className="download"><img alt="navigate right" src={downloadicon} /></a>
		</div>,
		config: {
		  titleBar: {
			enable: true
		  },
		  fadeIn: true,
		  fadeInSpeed: 500
		}
	  })
	}
	render(){		
		let {heading,desc,id,image_small} = this.props;
		
		return(
			<div className="item margin-top-40 col-lg-3 col-md-4 col-sm-6 col-xs-12">
				<PopupboxContainer onClosed={this.closePopupbox}/>
				<img id={`image_id_${id}`} alt={desc} src={image_small} onClick={this.openPopupbox} />
				<h3 className="margin-top-10">{heading}</h3>										
				<div className="margin-top-20 desc">
					<p dangerouslySetInnerHTML={createMarkup(desc)}></p>
				</div>
				<a className="margin-top-20" href="javascript:void(0)" onClick={this.handleDownload}>Download <img className="download_icon" src={downloadiconblack} alt="download" /></a>
			</div>
		)
	}	
}
export default PressImage;


// WEBPACK FOOTER //
// ./src/components/PressImage.js